function coalesce(...args) {
  let i;
  for (i = 0; i < args.length - 1; i += 1) {
    if (args[i] != null)
      return args[i];
  }
  return args[i];
}
export {
  coalesce
};
//# sourceMappingURL=coalesce.js.map